'use client'
import { Dropdown, Space, Flex } from 'antd'
import styles from './style.module.scss'
import { useLocale } from 'core/components/Locale'
import MenuItem from '../DropdownUI/MenuItem'
import { Airplay } from 'lucide-react'
import cls from 'classnames'
import { useParams } from 'next/navigation'
import { useAuthenticate } from 'core/components/Authenticate'
import { useHCRouter, HCNextLink } from '@/components/HCNextLink'
import { useState } from 'react'
import { useGetPublicServiceGetConfigQuery } from 'core/query/yapi/hk-web/AppConfig/query'
import { useGetRewardActivityParamsQuery } from 'core/query/yapi/hk-web/Reward/query'
import { useLiveList } from 'core/controller/live/liveList'
import useDefaultCoin from 'core/controller/contract/exchange/Header/useDefaultCoin'
import recordPCEvent from 'core/utils/RecordEvent/recordPCEvent'
import { useAppSetting } from '@/components/appStore'
type TMenuItem = {
  key: string
  title: string
  locale?: string
  sublocale?: string
  link?: string
  event?: string
  meta?: {
    auth?: boolean
    target?: '_blank' | '_self' | '_parent' | '_top'
    suffix?: string
  }
  children?: TMenuItem[]
}

export default function Menu() {
  const t = useLocale()
  const router = useHCRouter()
  const params = useParams()
  const user = useAuthenticate()
  const platform = useAppSetting('platform')
  const [openKeys, setOpenKeys] = useState([])

  const menus: Array<TMenuItem> = [
    {
      key: 'buyCrypto',
      title: t('header_047'),
      locale: 'header_047',
      children: [
        {
          key: 'topupCrypto',
          title: t('hotcoinWeb_v9_TopUp'),
          subtitle: t('hotcoinWeb_v9_TransferDigitalCurrencyTo'),
          locale: 'hotcoinWeb_v9_TopUp',
          sublocale: 'hotcoinWeb_v9_TransferDigitalCurrencyTo',
          link: 'assetManagement/topup',
          meta: {
            auth: true,
          },
        },
        {
          key: 'c2cBuy',
          title: t('home_v9_C2CBuyCoins'),
          subtitle: t('header_063'),
          locale: 'home_v9_C2CBuyCoins',
          sublocale: 'header_063',
          link: 'c2c/trade',
        },
        {
          key: 'creditCardBuy',
          title: t('creditCard_002'),
          subtitle: t('header_064'),
          locale: 'creditCard_002',
          sublocale: 'header_064',
          link: 'c2c/trade/creditCardIndex',
        },
      ],
    },
    {
      key: 'market',
      title: t('header_059'),
      locale: 'header_059',
      children: [
        {
          key: 'marketOverview',
          title: t('header_080'),
          subtitle: t('header_065'),
          locale: 'header_080',
          sublocale: 'header_065',
          link: 'market',
        },
        {
          key: 'industryData',
          title: t('hotcoinWeb_v1_2_21_IndustryData'),
          subtitle: t('header_066'),
          locale: 'hotcoinWeb_v1_2_21_IndustryData',
          sublocale: 'header_066',
          link: 'marketExplore/overview',
        },
      ],
    },
    {
      key: 'trade',
      title: t('header_048'),
      locale: 'header_048',
      children: [
        {
          key: 'spotTrade',
          title: t('header_007'),
          subtitle: t('header_067'),
          locale: 'header_007',
          sublocale: 'header_067',
          link: 'trade/exchange/?tradeCode=btc_usdt',
        },
        {
          key: 'marginTrade',
          title: t('marginAccount_001'),
          subtitle: t('header_069'),
          locale: 'marginAccount_001',
          sublocale: 'header_069',
          link: 'margin/trade/btc_usdt',
        },
        // {
        //   key: 'etfTrade',
        //   title: 'ETF专区',
        //   subtitle: '永无强平风险的杠杆',
        //   locale: 'header_041',
        //   sublocale: 'header_073',
        //   link: 'trade/btc3l_etf',
        // },
        {
          key: 'preMarketTrade',
          title: t('preMarket_001'),
          subtitle: t('preMarket_002'),
          locale: 'preMarket_001',
          sublocale: 'preMarket_002',
          link: 'preMarket',
        },
      ],
    },
    {
      key: 'contract',
      title: t('market_025'),
      locale: 'market_025',
      children: [
        {
          key: 'perpetualContract',
          title: t('contract_008'),
          subtitle: t('header_091'),
          locale: 'contract_008',
          sublocale: 'header_091',
          link: 'contract/exchange/trade/tradeName=btcusdt?type=1',
        },
        {
          key: 'deliveryContract',
          title: t('contract_372'),
          subtitle: t('header_092'),
          locale: 'contract_372',
          sublocale: 'header_092',
        },
        {
          key: 'simulationContract',
          title: t('swaps_silumation_006'),
          subtitle: t('header_074'),
          locale: 'swaps_silumation_006',
          sublocale: 'header_074',
          event: 'Contract_Simulation',
          link: 'contract/exchange/btcusdt', // contract/mock/f_ethf_usdt_quarter_d/ 交割
          meta: {
            auth: true,
          },
        },
        {
          key: 'copyContract',
          title: t('chargeback_orderBearer117'),
          subtitle: t('header_075'),
          locale: 'chargeback_orderBearer117',
          sublocale: 'header_075',
          link: 'chargeBack',
        },
        {
          key: 'cashbackActivity',
          title: t('hotcoinWeb_v101122_ContractPositionCashbackActivity'),
          subtitle: t('hotcoinWeb_v101122_BigBonusesAreWaiting'),
          locale: 'hotcoinWeb_v101122_ContractPositionCashbackActivity',
          sublocale: 'hotcoinWeb_v101122_BigBonusesAreWaiting',
          link: 'activity/cashback',
        },
      ],
    },
    {
      key: 'copyTrading',
      title: t('hotcoinWeb_v12_CopyContract'),
      locale: 'hotcoinWeb_v12_CopyContract',
      link: 'chargeBack',
      children: [],
    },
    {
      key: 'financial',
      title: t('financial_001'),
      locale: 'financial_001',
      children: [
        {
          key: 'earnCoin',
          title: t('financial_029'),
          subtitle: t('home_v1_22_HoldCoinsToEarn'),
          locale: 'financial_029',
          sublocale: 'home_v1_22_HoldCoinsToEarn',
          link: 'wealthManagement',
        },
        {
          key: 'borrowCoin',
          title: t('pledg_001'),
          subtitle: t('home_v1_22_PledgeDigitalAssetsTo'),
          locale: 'pledg_001',
          sublocale: 'home_v1_22_PledgeDigitalAssetsTo',
          link: 'pledgeBorrowMoney',
        },
        {
          key: 'dualCurrencyInvestment',
          title: t('home_v1_22_DualCurrencyInvestment'),
          subtitle: t('home_v1_22_BuyLowAndSell'),
          locale: 'home_v1_22_DualCurrencyInvestment',
          sublocale: 'home_v1_22_BuyLowAndSell',
          link: 'twoCoinsFinalcial',
        },
      ],
    },
    {
      key: 'more',
      title: t('header_084'),
      locale: 'header_084',
      children: [
        {
          key: 'inviteFriends',
          title: t('header_050'),
          subtitle: t('header_082'),
          locale: 'header_050',
          sublocale: 'header_082',
          link: 'user/ic',
          meta: {
            auth: false,
            suffix: 'hot',
          },
        },
        {
          key: 'benefitCenter',
          title: t('benefits_center_001'),
          subtitle: t('header_086'),
          locale: 'benefits_center_001',
          sublocale: 'header_086',
          link: 'benefitsCenter/home',
          event: 'Home_BenefitsCenter',
          meta: {
            suffix: 'hot',
          },
        },
        {
          key: 'payment',
          title: t('accountCoinTrade_278'),
          subtitle: t('header_079'),
          locale: 'accountCoinTrade_278',
          sublocale: 'header_079',
          link: 'pay/home',
          meta: {
            auth: true,
          },
        },
        {
          key: 'live',
          title: t('hotcoinWeb_v1_22_56_LiveStreaming'),
          subtitle: t('hotcoinWeb_v1_22_56_LatestMarketAnalysisAnd'),
          locale: 'hotcoinWeb_v1_22_56_LiveStreaming',
          sublocale: 'hotcoinWeb_v1_22_56_LatestMarketAnalysisAnd',
          link: 'live',
          isAnimationIcon: true,
        },
        {
          key: 'vipService',
          title: t('vip_001'),
          subtitle: t('vip_002'),
          locale: 'vip_001',
          sublocale: 'vip_002',
          link: 'vip',
          meta: {
            suffix: 'new',
          },
        },
        {
          key: 'startup',
          title: 'Startup',
          subtitle: t('header_070'),
          locale: 'header_083',
          sublocale: 'header_070',
          link: 'ieo',
        },
        {
          key: 'academy',
          title: t('learn_016'),
          subtitle: t('learn_017'),
          locale: 'learn_016',
          sublocale: 'learn_017',
          link: 'learn/index',
        },
        {
          key: 'nft',
          title: 'NFT',
          subtitle: t('header_085'),
          locale: 'nft_igo_044',
          sublocale: 'header_085',
          link: 'nft/home',
        },
        {
          key: 'research',
          title: t('hotcoinWeb_v1_22_502_ResearchInstitute'),
          subtitle: t('hotcoinWeb_v1_22_502_MarketHotspotsAndIndustry'),
          locale: 'hotcoinWeb_v1_22_502_ResearchInstitute',
          sublocale: 'hotcoinWeb_v1_22_502_MarketHotspotsAndIndustry',
          link: 'learn/index/?tab=research',
        },
        {
          key: 'helpCenter',
          title: t('header_003'),
          subtitle: t('header_087'),
          locale: 'header_003',
          sublocale: 'header_087',
          link: 'support/index',
        },
        {
          key: 'announcement',
          title: t('support_011'),
          subtitle: t('header_088'),
          locale: 'support_011',
          sublocale: 'header_088',
          link: 'support/notice',
        },
        {
          key: 'kolIncentive',
          title: t('home_v12_1_KOLIncentive'),
          subtitle: t('home_v12_1_KOLIncentive_description'),
          locale: 'home_v12_1_KOLIncentive',
          sublocale: 'home_v12_1_KOLIncentive_description',
          link: 'activity/kol-incentive-plan',
        },
        {
          key: 'starDrop',
          title: t('hotcoinWeb_v99_MeteorAirdrop'),
          subtitle: t('hotcoinWeb_v99_ReceiveAirdropRewards'),
          locale: 'hotcoinWeb_v99_MeteorAirdrop',
          sublocale: 'hotcoinWeb_v99_ReceiveAirdropRewards',
          link: 'campaign/templateSecond/starHome',
        },
      ],
    },
    // {
    //   key: 'newYear',
    //   title: '圣诞狂欢活动',
    //   locale: 'hotcoinWeb_v1_22_50_NewYearsDayCarnival_1',
    //   link: 'campaign/newYear',
    //   children: [],
    //   classNameItem: styles.newYearLink,
    // },
  ]

  const walletMenu = [
    {
      key: 'swap',
      title: t('hotcoinWeb_v1_12_2128889_Exchange'),
      locale: 'hotcoinWeb_v1_12_2128889_Exchange',
      link: 'swap',
      children: [],
    },
    {
      key: 'walletAssets',
      title: t('111aaff_v1_2_Assets'),
      locale: '111aaff_v1_2_Assets',
      link: 'assets',
      children: [],
    },
    {
      key: 'receive',
      title: t('hotcoinWeb_v1_12_2128889_TakeOver'),
      locale: 'hotcoinWeb_v1_12_2128889_TakeOver',
      link: 'receive',
      children: [],
    },
  ]

  const handleNavigation = (item: any) => {
    if (item.event) {
      recordPCEvent.record(item.event)
    }
    if (!user.loginData && item.meta?.auth) {
      router.push(`login`)
      return
    }
    // 模拟盘需判断永续跟交割
    // TODO 暂时处理方案
    if (item.key === 'simulationContract' && user?.loginData?.isActivateContract) {
      const url = window.location.href
      const urlParamsAry = url.split('/')
      const index = urlParamsAry.findIndex((item) => item === 'exchange')
      const code = urlParamsAry[index + 1]
      const bizType = parseURLContractCode(code).bizType
      if (bizType === 'perpetual') {
        router.push('contract/mock/f_btcf_usdt/')
      } else {
        router.push('contract/mock/f_ethf_usdt_quarter_d/')
      }

      // router.push('/simulation/exchange')
    } else if (item.key === 'industryData') {
      router.push(item.link, { target: '_self' })
    } else {
      router.push(item.link)
    }
  }

  const generateLink = (item: TMenuItem): string => {
    if (item.key === 'simulationContract' && user?.loginData?.isActivateContract) {
      return '/simulation/exchange'
    }
    if (item.meta?.auth && !user.loginData) {
      return 'login'
    } else {
      return item.link || 'javascript:void(0)'
    }
  }

  /* 默认交割币对路径 */
  const { liveIngList, refetchLiving } = useLiveList({
    enabled: openKeys.includes('live'),
  })

  const { perpetualPath, deliverPath } = useDefaultCoin()
  const { data: configData } = useGetPublicServiceGetConfigQuery()
  const { data: activityConfigData } = useGetRewardActivityParamsQuery()
  // const perpetual = perpetualData?.data?.data?.[0]?.perpetuals?.[0]

  // 遍历menus的children，给每个item加上一个label，label的值是MenuItem组件
  const currentMenus = menus.map((menu) => {
    let children = menu.children
    if (
      menu.key === 'more' &&
      ['zh_HK', 'zh_CN'].includes(params.lang as string) &&
      (!configData?.data?.data?.kolIncentive || !user.loginData)
    ) {
      children = menu.children?.filter((item) => item.key !== 'kolIncentive')
    }
    if (
      menu.key === 'contract' &&
      activityConfigData?.data?.data?.rebateStatus !== 1 &&
      activityConfigData?.data?.data?.rebateStatus !== 3
    ) {
      children = menu.children?.filter((item) => item.key !== 'cashbackActivity')
    }
    return {
      ...menu,
      children:
        children?.map((item) => {
          if (item.key === 'perpetualContract') {
            item.link = `contract/exchange/trade/?tradeName=${perpetualPath}`
          }
          if (item.key === 'deliveryContract') {
            item.link = `contract/exchange/trade/?tradeName=${deliverPath}`
          }
          return {
            ...item,
            label: (
              <MenuItem
                key={item.key}
                _key={item.key}
                leftIcon={<Airplay />}
                title={t(item.locale)}
                liveIngData={liveIngList}
                description={t(item.sublocale)}
                suffix={item?.meta?.suffix}
                link={generateLink(item)}
              />
            ),
          }
        }) || [],
    }
  })

  const getOverlayClassName = (children: any[]) => {
    return cls(styles['menu-dropdown'], {
      [styles['two-columns']]: children.length > 6,
    })
  }

  const onOpenChange = (open: boolean, menu) => {
    handleVisibleChange(menu.key, open)
    if (open) {
      refetchLiving()
    }
  }
  const handleVisibleChange = (key, open) => {
    if (open) {
      setOpenKeys([key])
    } else {
      setOpenKeys([])
    }
  }

  return (
    <div className={styles.menu}>
      <Flex gap="20px">
        {(platform === 'web3Wallet' ? walletMenu : currentMenus).map((menu) => (
          <Dropdown
            placement="bottom"
            menu={{ items: menu.children }}
            key={menu.key}
            overlayClassName={getOverlayClassName(menu.children)}
            onOpenChange={(open) => onOpenChange(open, menu)}
          >
            <HCNextLink
              className={cls(styles.menuItem, 'c7')}
              href={generateLink(menu)}
              target={menu?.meta?.target || ''}
            >
              <Space
                size={7}
                className={styles.fontMedium}
                style={{ color: openKeys.includes(menu.key) ? '#557bfa' : 'var(--c7)' }}
              >
                <span className={cls(['font-medium'])}>
                  {t(menu.locale)}
                  {menu.key === 'newYear' && <div className="hot-badge"></div>}
                </span>
                {menu.children?.length ? (
                  <i
                    className={cls(styles.downOutlined, 'iconfont iconbianzu22 f12')}
                    style={{ transform: openKeys.includes(menu.key) ? 'rotate(180deg)' : 'rotate(0deg)' }}
                  ></i>
                ) : null}
              </Space>
            </HCNextLink>
          </Dropdown>
        ))}
      </Flex>
    </div>
  )
}
